import { useContext } from 'react'
import Button from 'components/Button'
// import { LoaderContext } from 'context/loader'
import usePost from 'hooks/usePost'
import APIS from 'constants/api'
import { SnackBarContext } from 'context/SnackBarContext'

import AlertIcon from 'assets/svg/AlertIcon'
import Line from 'assets/svg/Line'
import {
  RemoveItemsContainer,
  HeadingWrapper,
  TopHeadingWrapper,
  Heading,
  Description,
  DeleteButtonWrapper,
} from 'styles/views/SaveAddress'
import { SvgWrapper } from 'styles/views/LocationNewUser'
import { CommonStyle } from 'styles/pages/Common'
import CloseIcon from 'assets/svg/CloseIcon'
import { useHomeContext } from 'context/HomeContext'

const RemoveItem = ({ onClose, productId, refetchOndcQuoteDetails }: any) => {
  // const [wishlist, setWishlist] = useState<{ [key: string]: boolean }>({})
  const customerId = localStorage.getItem('customerId')

  // const { setLoader } = useContext(LoaderContext)

  const { setShowSnackBar } = useContext(SnackBarContext)
  const { setCartCount, cartCount } = useHomeContext()
  const { mutateAsync } = usePost()

  const handleWishlistClick = async (productId: string) => {
    //setLoader(true)
    try {
      const res = await mutateAsync({
        url: APIS.ADD_WISHLIST,
        payload: {
          customerId: customerId,
          productId: [productId],
        },
      })
      if (res) {
        //setLoader(false)
        //setLoader(false)
        setCartCount(cartCount - 1)
        setShowSnackBar({ open: true, message: `${res?.m}`, severity: '' })
        onClose()
        //setLoader(false)
      }
    } catch (error) {
      //setLoader(false)

      return error
    }
  }

  const handleRemoveProduct = async (showSnackbar = true) => {
    //setLoader(true)
    try {
      const res = await mutateAsync({
        url: APIS.REMOVE_ITEM,
        payload: { productIds: [productId] },
      })
      if (res) {
        if (showSnackbar) {
          setShowSnackBar({ open: true, message: `Product Removed`, severity: '' })
        }

        refetchOndcQuoteDetails()
        //setLoader(false)
        setCartCount(cartCount - 1)
        onClose()
      }
    } catch (error) {
      //setLoader(false)
      return error
    }
  }
  // const handleRemoveProduct = async () => {
  //   //setLoader(true)

  //   try {
  //     const res = await mutateAsync({
  //       url: APIS.REMOVE_ITEM,
  //       payload: { productIds: [productId] },
  //     })
  //     if (res) {
  //       setShowSnackBar({ open: true, message: `Product Removed`, severity: '' })
  //       refetchOndcQuoteDetails()
  //       //setLoader(false)
  //       onClose()
  //     }
  //   } catch (error) {
  //     //setLoader(false)
  //     return error
  //   }
  // }

  return (
    <RemoveItemsContainer>
      <SvgWrapper onClick={onClose} className="cross-icon">
        <CloseIcon />
      </SvgWrapper>
      <CommonStyle>
        <HeadingWrapper className="remove-item">
          <TopHeadingWrapper>
            <AlertIcon />
            <Heading>Remove 1 item</Heading>
          </TopHeadingWrapper>
          <Description className="h1r">Are you sure you want to remove this item?</Description>
        </HeadingWrapper>
      </CommonStyle>
      <DeleteButtonWrapper>
        <Button label="REMOVE" variant="outline" type="submit" className="skip" onClick={handleRemoveProduct} />
        <Line />
        <Button
          label="Move To Wishlist"
          variant="contained"
          type="submit"
          className="small"
          onClick={() => {
            if (customerId) {
              handleWishlistClick(productId)
              handleRemoveProduct(false)
            }
          }}
        />
      </DeleteButtonWrapper>
    </RemoveItemsContainer>
  )
}

export default RemoveItem
